import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFuel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.36844 15.1447L7.00072 15.2183L7.36844 15.1447ZM5.05263 5.88156L5.34072 5.64149L5.32983 5.62842L5.3178 5.61639L5.05263 5.88156ZM1 3.19077C0.792893 3.19077 0.625 3.35866 0.625 3.56577C0.625 3.77287 0.792893 3.94077 1 3.94077V3.19077ZM10.1155 10.1685C9.39576 10.4769 8.49424 11.0574 7.83153 11.8964C7.16199 12.7441 6.73036 13.8664 7.00072 15.2183L7.73616 15.0712C7.51738 13.9773 7.85768 13.0733 8.42007 12.3613C8.98929 11.6407 9.77972 11.1283 10.4109 10.8578L10.1155 10.1685ZM7.00072 15.2183C7.28546 16.642 7.2704 17.7183 7.016 18.4179C6.89141 18.7605 6.71434 18.9999 6.49825 19.1552C6.28314 19.3098 6.0014 19.4013 5.63158 19.4013V20.1513C6.13019 20.1513 6.57213 20.0257 6.93597 19.7642C7.29883 19.5034 7.55597 19.1276 7.72085 18.6742C8.04541 17.7817 8.03035 16.5422 7.73616 15.0712L7.00072 15.2183ZM5.63158 19.4013C5.36326 19.4013 4.93202 19.3998 4.5388 18.9504C4.12283 18.475 3.69079 17.4311 3.69079 15.1447H2.94079C2.94079 17.49 3.37717 18.7618 3.97436 19.4443C4.5943 20.1528 5.32096 20.1513 5.63158 20.1513V19.4013ZM3.69079 15.1447C3.69079 12.3764 4.78331 11.0142 5.57876 9.85716C5.97273 9.28411 6.34432 8.6963 6.37706 7.9978C6.41055 7.28323 6.09064 6.54139 5.34072 5.64149L4.76455 6.12163C5.462 6.95856 5.64866 7.51936 5.62788 7.96268C5.60635 8.42208 5.3628 8.84743 4.96072 9.43227C4.16406 10.5911 2.94079 12.1236 2.94079 15.1447H3.69079ZM5.3178 5.61639C5.03394 5.33253 4.79502 5.05853 4.53073 4.77536C4.27312 4.49935 4.00188 4.22672 3.68553 3.98945C3.03601 3.50231 2.23167 3.19077 1 3.19077V3.94077C2.08412 3.94077 2.72715 4.20816 3.23553 4.58945C3.49812 4.78639 3.73346 5.02034 3.98244 5.2871C4.22472 5.54669 4.49238 5.85163 4.78747 6.14672L5.3178 5.61639Z",
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2631 2.25V18.7763C10.2631 19.3286 10.7108 19.7763 11.2631 19.7763H20.842C21.3943 19.7763 21.842 19.3286 21.842 18.7763V2.25C21.842 1.69772 21.3943 1.25 20.842 1.25H11.2631C10.7108 1.25 10.2631 1.69772 10.2631 2.25Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1052 19.5724H22C22.3451 19.5724 22.625 19.8522 22.625 20.1974V21.6711C22.625 22.0163 22.3451 22.2961 22 22.2961H10.1052C9.76005 22.2961 9.48022 22.0163 9.48022 21.6711V20.1974C9.48022 19.8522 9.76005 19.5724 10.1052 19.5724Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.9541,
			y: 3.94077,
			width: 6.19737,
			height: 6.19737,
			rx: .625,
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.7865 3.61337L1.51234 4.95368C1.32257 5.1533 1.32997 5.46878 1.52888 5.65929L3.78291 7.81803C3.99079 8.01712 4.32341 8.00002 4.50978 7.78067L5.63148 6.46051",
			stroke: "#293235",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.72058,
			y: 5.28024,
			width: 1.54535,
			height: 3.49409,
			rx: .25,
			transform: "rotate(-45.6225 1.72058 5.28024)",
			fill: "#DBE4E8"
		})
	]
});
const ForwardRef = forwardRef(SvgFuel);
export { ForwardRef as ReactComponent };
